import * as React from 'react';

import { Autocomplete } from '@emburse/ui-core';

import { IGenericOption } from '@Shared/constants';

import { useAllowedVendorsQuery } from './allowedVendorsQueries';

type VendorRestrictionOption = { label: string; value: string };

interface IVendorRestrictionsFieldProps {
  defaultValue?: string;
  onChange: (value: string) => void;
}

export const VendorRestrictionsField: React.FC<IVendorRestrictionsFieldProps> = ({ defaultValue, onChange }) => {
  const [value, setValue] = React.useState<VendorRestrictionOption | null>(null);

  const allowedVendors = useAllowedVendorsQuery();
  const options = (allowedVendors.data || [])
    .map((vendor) => ({
      label: vendor.name,
      value: vendor.id
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  React.useEffect(() => {
    if (allowedVendors.isSuccess && options.length > 0) {
      setValue(options.find((option) => defaultValue === option.value) || null);
    }
  }, [allowedVendors.isSuccess]);

  return (
    <Autocomplete
      label={'Allowed Vendors'}
      value={value}
      options={options}
      getOptionLabel={(option: any) => option.label}
      onChange={(_: any, newValue: IGenericOption) => {
        setValue(newValue);
        onChange(newValue?.value || '');
      }}
    />
  );
};
